// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","search_form":"Home_search_form__1+mEg","container_home":"Home_container_home__QNq3E","noposts":"Home_noposts__0FU7t"};